export const imageUrls = [
  '/images/FASST_Flexi_Couleur.svg',
  '/images/background-account-1.svg',
  '/images/background-fill.svg',
  '/images/chevron-left.svg',
  '/images/ic-menu.svg',
  '/images/ic-menu@3x.png',
  '/images/icon-comparer@3x.png',
  '/images/icon-offre-dark@2x.png',
  '/images/illu-equipe@3x.png',
  '/icons/icon-calendar-check.svg',
  '/icons/icon-comment-quote.svg',
  '/icons/icon-copy.png',
  '/icons/icon-doc.svg',
  '/icons/icon-equipe-dark.svg',
  '/icons/icon-fleche.svg',
  '/icons/icon-layer-plus.svg',
  '/icons/icon-pen-field.png',
  '/icons/icon-pen-to-square.svg'
];
